import * as tagUtil from "./LogTagData";

const loginSuccessEvent = () => {
    let data = {
        page_event: "view",
        page_form_event : "success",
        page_form_name : "ebu: self service: login password form",
        service_application_event : "finish",
        service_application_name : "ebu: self service: login (transaction)",
        visitor_login_type: "[Password]"
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const loginErrorEvent = (err) => {
    let data = {
        page_form_event: "error",
        page_errors: err,
        page_name : "ebu: self sevice: login: journey error"
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const registerClickEvent = () => {
    let data = {
        link_type: "o",
        link_name: "vodacom: business: self service: two factor authentication: register"
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const forgotClickEvent = (credential) => {
    let data = {
        link_type: "o",
        link_name: `vodacom: business: self service: two factor authentication: ${credential}`
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const loginPageLoad = () => {
    let data = {
        page_event: "view",
        page_name: "vodacom: business: self service: two factor authentication",
        page_channel: "accounts",
        page_master_tab: "business",
        page_category: "two factor authentication",
        page_type: "content",
        service_application_event: "start",
        service_application_name: "vodacom: business: self service: two factor authentication: login",
        service_application_step: "vodacom: business: self service: two factor authentication: login details",
    };

    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const loginClickEvent = (userName) => {
    let data = {
        page_form_event: "started",
        page_form_name: "ebu: self service: login password form",
        service_application_event: "start",
        service_application_name: "ebu:self service: login (transaction)",
        service_application_type: "transaction",
        visitor_login_details: userName,
        link_type: "o",
        link_name: "vodacom: business: self service: two factor authentication: login"

    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

const credentialsErrorEvent = (err) => {
    let data = {
        page_form_event: "error",
        page_errors: err,
        page_name : "vodacom: business: self service: two factor authentication: username & password error"
    };

    try {
        window.tagUtil.link(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};





export {
    loginPageLoad,
    loginSuccessEvent,
    loginErrorEvent,
    loginClickEvent,
    registerClickEvent,
    credentialsErrorEvent,
    forgotClickEvent
};
